<template>
  <div :class="['wrap', {'no-wrap': activeFlag}]">
    <mt-header :title="$Global.Mobile.title" class="mi-back">
      <mt-button icon="back icon_font" slot="left" @click='back' v-if='!activeFlag'></mt-button>
      <mt-button slot="right" @click='trigger'>
          <i class="iconfont icon_font">&#xe60b;</i>
      </mt-button>
    </mt-header>
    <mt-tab-container class='menu_right' v-model="selectFlag" swipeable  @click.native='trigger'>
        <mt-tab-container-item id="select" >
          <mt-cell v-for="(item,index) in menuList" :key='index'>
            <router-link :to='item.link' :class="['max_wid', {'active': index==$Global.Mobile.index}]">{{item.text}}</router-link> 
          </mt-cell>
        </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        title: '首页',
        activeFlag: false,
        selectFlag: 'none',
        menuList: [
          {
            link: '/mobileIndex/mobile',
            text: '首页'
          },
          {
            link: '/mobileIndex/mobileSolutionSys',
            text: '系统性解决方案'
          },
          {
            link: '/mobileIndex/mobileSolution',
            text: '主要产品'
          },
          {
            link: '/mobileIndex/mobileBoao',
            text: '博鳌亚洲论坛大会'
          },
          {
            link: '/mobileIndex/mobileAbout',
            text: '关于我们'
          }
        ]
      }
    },
    methods: {
      back(){
        window.history.back()
      },
      trigger(){
        if (this.selectFlag == 'select') {
          this.selectFlag = 'none'
        }else{
          this.selectFlag = 'select'
        }
        this.activeFlag = !this.activeFlag
      }
    },
    mounted() {
      console.log('-')
      this.$Global.Mobile.title = this.$router.currentRoute.meta.title
      this.$Global.Mobile.index = this.$router.currentRoute.meta.activeIndex
    },
  }
</script>

<style lang="less" scoped>
.wrap{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 99;
  background: rgba(0,0,0,0);
  transition:  2s;
}
.no-wrap{
  background:none
}
/deep/.mint-tab-container-item{
  height:100vh;
  background: white;
  .mint-cell:last-child{
    background-image: none;
  }
}
/deep/.mi-back{
  background-color: white;
  color: #666666;
  height: 90px;
  .mint-header-title{
    color: black;
  }
  h1{
    font-size:33px;
  }
  .icon_font{
    font-size: 40px;
  }
}
/deep/.menu_right{
  right: 0;
  .mint-cell-wrapper{
    background-image:none;
    display: block; height: 100%; line-height: 48px; text-align: right;
  }
}
// 
.max_wid{
  display: block; width: 100%;
}
.active{
  color: #3e6ae5
}
</style>
